/**
 * 函数节流
 * @param {function} func 受保护方法
 * @param {number} wait 节流时间间隔
 */
export const throttle = (func, wait = 1000) => {
  let timer = null
  return function () {
    if (timer === null) {
      timer = setTimeout(() => {
        func.apply(this, arguments)
        timer = null
      }, wait)
    }
  }
}
export const btnsFilter = (btnsList) => {
  let whiteList = ['会签', '知会', '提交', '驳回发起人', '已阅']
  let res = []
  let len = btnsList.length
  for (let i = 0; i < len; i++) {
    let item = btnsList[i]
    if (whiteList.indexOf(item.factorname) > -1) { 
      if (item.factorname === '驳回发起人') {
        item.factorname = '驳回'
      }
      res.push(item)
    }
  }
  return res
}